<template>
  <div>
    <!-- BEGIN CONTENT BODY -->
    <!-- BEGIN PAGE HEADER-->
    <breadcrumb-bar
        :crumbs="[{name:'Workspace', link:'Workspace'},{name:'Organization Forms'}]"></breadcrumb-bar>
    <!--END PAGE HEADER-->
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-12">
            <organization-forms type="organization_organization"></organization-forms>
          </div>
        </div>
      </div>
    </div>
    <!--END CONTENT BODY-->
  </div>
</template>
<script>
    import FORM from '@/components/widgets/FormCRUD';
    import Breadcrumbs from '@/components/Breadcrumbs'
    import {mapActions} from 'vuex';

    export default {

    data() {
      return {}
    },

    methods: {
      ...mapActions([
        'loadWorkspace'
      ]),
    },

    components: {
      'organization-forms': FORM,
      'breadcrumb-bar': Breadcrumbs
    }


  }
</script>



// WEBPACK FOOTER //
// OrganizationForms.vue?25584a68